export default class EstatedValuations {
  constructor(obj) {
    if (obj.valuations) {
      this.fips = obj.valuations.fips;
      this.apn = obj.valuations.apn;
      this.value = obj.valuations.value;
      this.high = obj.valuations.high;
      this.low = obj.valuations.low;
      this.forecast_standard_deviation =
        obj.valuations.forecast_standard_deviation;
      this.date = obj.valuations.date;
    }
  }
}
